import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { unescape } from 'lodash';
import { data_item } from 'src/app/misc/interface/data';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-category-ous',
  templateUrl: './category-ous.component.html',
  styleUrls: ['./category-ous.component.scss']
})
export class CategoryOusComponent {

  data?: any[];
  @Input() current?: any;
  @Input() colors: string[] = ['#04524d', '#138884', '#02afa9', '#1f798d', '#0a2438']
  @Input() currentDataItem: data_item | null = null;
  loading:boolean = false;
  visible: boolean = false;

  showDialog() {
    this.visible = true;
  }

  constructor(private router: Router, private dataService: DataService) { }

  staticURL = GlobalConstants.staticFilesURL;

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentDataItem']) {
      this.currentDataItem = changes['currentDataItem'].currentValue;
    }
    if (changes['current']) {
      if (this.current) {
        this.getOus(this.current?.id!);
      }
    }
  }

  async getOus(categoryId: number) {
    try {
      this.loading = true;
      let res = await this.dataService.getData('ou/category/filter/' + categoryId);
      if (res.error) {
        this.loading = false;
        return;
      }
      console.log('DATA API',res.data);
      if (res.data && res.data.length > 0) {
        this.current = res.data[0];
      }
      if (res.data && res.data[0].children && res.data[0].children.length > 0) {
        
        this.data = res.data[0].children?.filter((e:any) => e.data_counter && e.data_counter.length > 0);
        this.data = this.data!.map(e => {
          e.parent = res.data[0];
          return e;
        });
      } 
      this.loading = false;
    } catch (e) {
      console.log(e);
    }
  }

  changeData(data: OrganizationUnit | undefined) {
    if (data) {
      console.log('CURRENT',data,this.data);
      let available = this.data?.find(e => e._id == this.current?._id);
      if (!available) {
        this.data?.push(this.current!);
      }
      this.current = data;
      this.getOus(this.current.id!);
    }
  }

  sortByDepth(items: OrganizationUnit[] | undefined) {
    console.log(items)
    if (items) {
      return items.sort((a: any, b: any) => {
        return b.depth - a.depth;
      });
    } else {
      return []
    }

  }

  reverse() {
    if (this.current != undefined && this.current.parent != undefined && this.current.parent.id != undefined) {
      this.changeData(this.current.parent);
    }
  }

  submitFilter() {
    this.visible = false;
    if (this.current) {
      console.log('CURRENT DATA',this.current);
      this.router.navigate(['/category/', this.current.id])
    }
  }

  checkEnabled(): boolean {
    return (this.current && this.current.parent && this.current.parent.id) != undefined ? true : false;
  }

}
